


import React, { useEffect, useRef, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MdOutlineBlock, MdSearch, MdEdit, MdDelete, MdRemoveRedEye, MdMode } from "react-icons/md";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Sort from '../../assets/image/sort-down-alt.svg'
import Filter from '../../assets/image/filter.svg'
import Dummy from '../../assets/image/user-circle.svg'
import Pagination from '../../Components/Pagination/Pagination';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import { Modal } from 'react-bootstrap';
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Import icons for dropdown arrow
import addPhoto from '../../assets/image/addphoto.svg';
import Loader from '../../Components/Loader/Loader';

function AddSchool() {
    const [teacherName, setTeacherName] = useState('')
    const [teacherEmail, setTeacherEmail] = useState('')
    const [emailErr, setEmailErr] = useState("")
    const [number, setNumber] = useState('')
    const [countryCode, setCountryCode] = useState("");
    const [delet, setDelet] = useState(false);
    const deleteClose = () => setDelet(false);
    const location = useLocation()
    const [gender, setGender] = useState("")
    const [school, setschool] = useState();
    const [selectedCode, setSelectedCode] = useState("");
    const [isChecked, setIsChecked] = useState(true);
    const [user, setUser] = useState()
    const navigate = useNavigate();
    const [gradeId, setGradeId] = useState([]);
    const [file, setFile] = useState()
    const countryCodes = ["P1", "P2", "P3"];
    const [gradeList, setGradeList] = useState([])
    const [teacherid, setTeacherid] = useState('')
    const [updateSchool, setUpdateSchool] = useState(false)
    const [isOpen, setIsOpen] = useState(false);

    const handleCheckboxChange = () => {
        const newCheckedState = !isChecked;
        setIsChecked(newCheckedState);

        if (newCheckedState) {
            setSelectedCode(""); // Reset when checked
        }
    };
    console.log(location)
    const goBack = () => {
        navigate(-1); // Navigates back to the previous page
    };
    const [image, setImage] = useState(null);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        setFile(file)
        if (file) {
            setImage(URL.createObjectURL(file));
        }

    };

    useEffect(() => {
        setschool(location?.state?.schoolDetails)
    }, [])

    const addTeacher = async (e) => {
        // Validate required fields
        if (!teacherName) return toast.error("Teacher name is required");
        if (!teacherid) return toast.error("Teacher Id is required");
        if (!teacherEmail) return toast.error("Email is required");
        if (!number) return toast.error("Phone number is required");
        if (!countryCode) return toast.error("Country code is required");
        // Email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(teacherEmail)) return toast.error("Invalid email format");
        if (gradeId.length === 0) return toast.error("At least one Grade is required");
        if (!isChecked) {

            if (!selectedCode) {
                return toast.error("Current priority area is required.")
            }
        }
        const data = new FormData();
        data.append("name", teacherName);
        data.append("school_id", location.state.school);
        data.append("email", teacherEmail);
        data.append("teacher_unique_id", teacherid);
        data.append("phone", number);
        data.append("gender", gender);
        data.append("grade_id", JSON.stringify(gradeId));
        data.append("country_code", countryCode);
        selectedCode && data.append("current_priority_area", selectedCode);
        file && data.append("image", file);
        if (isChecked) {
            data.append("current_priority_area", "");
        }
        setLoading(true)
        try {
            const response = await handleApiCall("post", endpoint.addTeacher, data);
            console.log(response, "Add Teacher");
            if (response?.data?.code === 200) {
                setLoading(false)
                toast.success(response?.data?.message);
                setTimeout(() => {
                    navigate("/school-management/view-user", { state: { id: location.state.school } });
                }, 1000);
            } else {
                setLoading(false)
                toast.error(response?.response?.data?.errorMessage || "Failed to add teacher");
            }
        } catch (error) {
            setLoading(false)
            console.error("Error adding teacher:", error);
            toast.error("Something went wrong!");
        }
    };
    useEffect(() => { getGreadList(); }, []);
    const getGreadList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.gradeList}`, {});
            if (response?.data?.code === 200) setGradeList(response?.data?.data?.gradeList);
            else toast.error(response?.response?.data?.message);
        } catch (e) { console.log("Error fetching region list:", e); }
    };
    const [isBothManuallySelected, setIsBothManuallySelected] = useState(false);
    const handleGradeSelection = (selectedId) => {
        setGradeId((prev) => {
            let updated;

            if (prev.includes(selectedId)) {
                updated = prev.filter((id) => id !== selectedId);
            } else {
                updated = [...prev, selectedId];
            }

            return updated;
        });

        setIsOpen(false); // Close dropdown
    };

    const handleSelectBoth = () => {
        const allIds = gradeList.map((item) => item._id);

        if (isBothSelected) {
            // Uncheck all
            setGradeId([]);
            setIsBothManuallySelected(false);
        } else {
            // Check all
            setGradeId(allIds);
            setIsBothManuallySelected(true);
        }

        setIsOpen(false); // Close dropdown
    };
    const allIds = gradeList.map((item) => item._id);
    const isBothSelected = gradeId.length === allIds.length;


    const UpdateTeacher = async (e) => {

        // Validate required fields
        if (!teacherName) return toast.error("Teacher name is required");
        if (!teacherid) return toast.error("Email is required");
        if (!teacherEmail) return toast.error("Email is required");
        if (!number) return toast.error("Phone number is required");
        // Email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(teacherEmail)) return toast.error("Invalid email format");
        if (!countryCode) return toast.error("Country code is required");
        // Phone number validation (10-digit check for example)

        if (!isChecked) {

            if (!selectedCode) {
                return toast.error("Current priority area is required.")
            }
        }
        setLoading(true)

        const data = new FormData();
        data.append("name", teacherName);
        data.append("school_id", location.state.school);
        data.append("email", teacherEmail);
        data.append("teacher_unique_id", teacherid);
        data.append("country_code", countryCode);
        data.append("phone", number);
        data.append("gender", gender);
        data.append("grade_id", JSON.stringify(gradeId));
        data.append("id", location?.state?.item?._id);
        selectedCode && data.append("current_priority_area", selectedCode);
        file && data.append("image", file);
        try {
            const response = await handleApiCall("put", endpoint.updateTeacher, data);
            console.log(response, "Add Teacher");
            if (response?.data?.code === 200) {
                setLoading(false)
                toast.success(response?.data?.message);
                setTimeout(() => {
                    goBack()
                }, 1000);
            } else {
                setLoading(false)
                toast.error(response?.response?.data?.errorMessage || "Failed to add teacher");
            }
        } catch (error) {
            setLoading(false)
            console.error("Error adding teacher:", error);
            toast.error("Something went wrong!");
        }
    };
    const editData = () => {
        if (location?.state?.screen === 'edit') {
            console.log(location.state, "Dataa==>>")
            setUpdateSchool(true)
            setTeacherName(location?.state?.item?.full_name)
            setTeacherEmail(location?.state?.item?.email)
            setNumber(location?.state?.item?.phone)
            setTeacherid(location?.state?.item?.teacher_unique_id)
            setGender(location?.state?.item?.gender)
            setCountryCode(location?.state?.item?.country_code)
            setSelectedCode(location?.state?.item?.current_priority_area)
            setGradeId(location.state.item.teacher_grade.map((g) => g.grade_id) || []);
            setImage(location?.state?.item?.image)
            if (location?.state?.item?.current_priority_area) {
                setIsChecked(false);
            }
        }
        else {
            setUpdateSchool(false)
            setSelectedCode('')
            setTeacherName("");
            setTeacherEmail("");
            setNumber("");
            setTeacherid("");
            setGender("");
            setIsChecked(true)
        }
    }

    useEffect(() => {
        editData()
    }, [])

    const dropdownRef = useRef(null);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);
    const [loading, setLoading] = useState(false)

    console.log(gradeId, "Check Id")
    return (
        <>
            <Toastify />
            <Loader isLoading={loading} /> {/* Call Loader */}
            <form className="common-table-wrapper m-0 px-2 " >
                <p className=' font-bold  text-black text-[30px]'>{school?.name} <span className=' text-gray-400 text-[18px]'>   {" " + school?.school_address}</span></p>
                <div className=" my-3">
                    <div className='flex gap-2 justify-start items-center'>
                        <h2 className=' mr-5 text-[30px]'>{location?.state?.school?.name}</h2>
                        <p className=' gap-5 flex text-gray-300 font-bold'>{location?.state?.school?.school_address}</p>
                    </div>
                </div>
                <div className="flex items-start gap-4">
                    {/* Hidden File Input */}
                    <input
                        type="file"
                        id="fileInput"
                        className="hidden"
                        accept="image/*"
                        onChange={handleImageChange}
                    />
                    {/* Label acts as a button */}
                    <label
                        htmlFor="fileInput"
                        className="flex items-center justify-center w-24 h-24 rounded-full border border-black cursor-pointer"
                    >
                        {image ? (
                            <img
                                src={image}
                                alt="Selected"
                                className="w-full h-full rounded-full object-cover"
                            />
                        ) : (
                            <img
                                src={addPhoto}
                                className=" object-cover p-2"></img>

                        )}
                    </label>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 px-2 py-3">
                    <input
                        type="text"
                        placeholder="Teacher Name"
                        required
                        maxLength={150}
                        value={teacherName}
                        onChange={(e) => {
                            let value = e.target.value;

                            // Remove leading non-alphanumeric characters (spaces and special chars)
                            value = value.replace(/^[^a-zA-Z0-9]+/, "");

                            setTeacherName(value);
                        }}
                        className="p-2 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 px-2 pb-3 ">
                    <input
                        type="text"
                        placeholder="Teacher ID"
                        required
                        maxLength={150}
                        value={teacherid}
                        onChange={(e) => {
                            let value = e.target.value;

                            // Remove leading characters that are not alphanumeric
                            value = value.replace(/^[^a-zA-Z0-9]+/, "");

                            setTeacherid(value);
                        }}
                        className="p-2 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    />
                    <div>
                        <input
                            type="email"
                            placeholder="Email"
                            required
                            value={teacherEmail}
                            onKeyPress={(e) => {
                                // Prevent space key from being typed
                                if (e.key === " " || e.code === "Space") {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                let value = e.target.value.replace(/\s/g, ''); // Remove spaces
                                setTeacherEmail(value); // Set the value without spaces

                                // Email format validation
                                if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                                    setEmailErr("Please enter a valid email.");
                                } else {
                                    setEmailErr('');
                                }
                            }}
                            className="p-2 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                        />
                        {emailErr && <p className="text-red-500 text-xs mt-1">{emailErr}</p>}
                    </div>

                    <input
                        type="text"
                        placeholder="Country Code"
                        required
                        maxLength={5}
                        value={countryCode}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\s/g, ''); // Remove spaces
                            if (/^[+0-9,]*$/.test(value)) { // Only allow numbers, plus, and commas
                                setCountryCode(value);
                            }
                        }}
                        className="p-2 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    />
                    <input
                        type="text"
                        placeholder="Phone Number"
                        required
                        maxLength={17}
                        value={number}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\s/g, ''); // Remove spaces
                            if (/^[0-9]*$/.test(value)) { // Only allow digits
                                setNumber(value);
                            }
                        }}
                        className="p-2 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    />
                    <select
                        onChange={(e) => setGender(e.target.value)}
                        required
                        className="p-2 bg-[#F6F6F6]  font-bold border-[1px] border-black rounded-md focus:outline-none w-full text-left flex justify-between items-center"
                        value={gender} // Bind value to state
                    >
                        <option value="" disabled>
                            Gender
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                    <div className="relative w-full" ref={dropdownRef}>
                        <button
                            type="button"
                            onClick={() => setIsOpen(!isOpen)}
                            className="p-2 bg-[#F6F6F6] font-bold border-[1px] border-black rounded-md focus:outline-none w-full text-left flex justify-between items-center"
                        >
                            <span className="truncate">
                                {isBothSelected
                                    ? "Both"
                                    : gradeId.length > 0
                                        ? gradeList
                                            .filter((item) => gradeId.includes(item._id))
                                            .map((item) => item.name)
                                            .join(", ")
                                        : "Choose Grades"}
                            </span>
                            {isOpen ? (
                                <FaChevronUp className="text-gray-500" />
                            ) : (
                                <FaChevronDown className="text-gray-500" />
                            )}
                        </button>

                        {isOpen && (
                            <div className="absolute left-0 mt-2 w-full bg-white border-[1px] border-black rounded-md shadow-lg z-10 p-2 max-h-48 overflow-y-auto">
                                {gradeList.length > 0 ? (
                                    <>
                                        {gradeList.map((item) => (
                                            <label key={item._id} className="flex items-center space-x-2 mb-2 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    value={item._id}
                                                    checked={gradeId.includes(item._id)}
                                                    onChange={() => handleGradeSelection(item._id)}
                                                    className="w-4 h-4"
                                                />
                                                <span>{item.name}</span>
                                            </label>
                                        ))}

                                        {/* Virtual "Both" checkbox */}
                                        <label className="flex items-center space-x-2 mb-2 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={isBothSelected}
                                                onChange={handleSelectBoth}
                                                className="w-4 h-4"
                                            />
                                            <span>Both</span>
                                        </label>
                                    </>
                                ) : (
                                    <p className="text-gray-500 text-sm">No grades available</p>
                                )}
                            </div>
                        )}
                    </div>
                </div>



                <div className="flex gap-2 px-2 py-2 items-center">
                    <input
                        type="checkbox"
                        className="w-3 h-3"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                    />
                    <span className="font-bold">New teacher?</span>
                </div>
                <div className="relative w-[22%]">

                    <div className="flex bg-[#F6F6F6] border-[1px] border-black rounded-md overflow-hidden">
                        {/* Dropdown for Country Code */}
                        <select
                            className={`p-2 border-r border-gray-300 text-gray-700 focus:outline-none w-full 
            ${isChecked ? "bg-gray-200 text-gray-500 cursor-not-allowed" : "bg-white"}`}
                            value={selectedCode}
                            disabled={isChecked}
                            onChange={(e) => setSelectedCode(e.target.value)}
                        >
                            <option>Current priority area*</option>
                            {countryCodes.map((code) => (
                                <option key={code} value={code}>
                                    {code}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Required Asterisk */}
                    {/* <span className="absolute top-0 right-1 text-red-500 text-lg font-bold">*</span> */}
                </div>

                <div className=' flex gap-3  mt-3'>
                    <div onClick={() => navigate(-1)}

                        className="  text-black  font-bold inline-flex cursor-pointer justify-center px-4 ms-2 items-center hover:bg-[#F6F6F6] border-black rounded-md border-[1px] py-2"
                    >
                        Cancel
                    </div>
                    <button disabled={loading} type='button' onClick={() => { updateSchool ? UpdateTeacher() : addTeacher() }}
                        className="text-white bg-[#994263] px-5 font-bold inline-flex cursor-pointer justify-center ms-2 items-center py-2 hover:bg-[#e6e0e2] hover:text-black border-[#994263] rounded-md border-[1px]"
                    >
                        {updateSchool ? "Update" : "Add"}
                    </button>

                </div>



            </form>

        </>
    )
}

export default AddSchool
